import { html, render } from "lit-html";
import Input from "../engine/input";

class LookDialog {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.dialog = document.querySelector(".dialog");
    this.isDirty = true;
  }

  activate(context) {
    this.overlay.classList.add("is-visible");
    this.dialog.classList.add("is-visible");
    this.dialog.classList.add("is-alert");
    render(this.getDialogTemplate(context), this.dialog);
    this.okButton = this.dialog.querySelector(".button-ok");
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.dialog.classList.remove("is-visible");
    this.dialog.classList.remove("is-alert");
  }

  handleClick(ev) {
    if (!this.dialog.contains(ev.target) || ev.target.matches("button.button-ok")) {
      document.dispatchEvent(new CustomEvent("ui.transition", {
        detail: {
          command: "CloseDialog",
        }
      }));
    } else {
      this.okButton.focus();
    }
  }

  handleInput(input) {
    switch (input) {
      case Input.MoveDown:
      case Input.MoveLeft:
      case Input.MoveRight:
      case Input.MoveUp:
      case Input.FocusLeft:
      case Input.FocusRight:
      case Input.FocusNext:
        this.okButton.focus();
      break;

      case Input.Ok:
      case Input.Cancel:
        document.dispatchEvent(new CustomEvent("ui.transition", {
          detail: {
            command: "CloseDialog",
          }
        }));
      break;
    }
    return false;
  }

  getDialogTemplate(context) {
    return html`
      <p>${context.description}</p>
      <footer class="dialog-footer">
        <button class="button-ok">Ok</button>
      </footer>
    `;
  }

  render(stage) {
    return;
  }
}

export default LookDialog;
